// Utility to get a cookie value by name
function getCookie(name) {
  const value = document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='));
  return value ? decodeURIComponent(value.split('=')[1]) : null;
}

function updateQuotifyVisibility() {
  const count = getCookie('quotify_cart_count');
  const btn = document.querySelector('.quotify-sticky-cart-btn');
  const sidebar = document.querySelector('.quotify-sidebar'); // adjust selector if needed

  if (!btn) return;

  if (!count || count === '0') {
    btn.style.display = 'none';
    if (sidebar) sidebar.style.display = 'none';
  } else {
    btn.style.display = '';
    if (sidebar) sidebar.style.display = '';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  updateQuotifyVisibility();

  // Observe changes to the cart count element
  const cartCountEl = document.querySelector('[data-quotify-cart-count]');
  if (!cartCountEl) return;

  const observer = new MutationObserver(updateQuotifyVisibility);

  observer.observe(cartCountEl, {
    characterData: true,
    childList: true,
    subtree: true
  });
});
